let cachedCryptoJS = null // 缓存动态加载的CryptoJS模块
export async function getAesKey() {
  // #ifdef H5
  if (!cachedCryptoJS) {
    cachedCryptoJS = await import('crypto-js') // 首次调用时动态加载
  }
  return cachedCryptoJS.default.lib.WordArray.random(16).toString(cachedCryptoJS.default.enc.Hex)
  // #endif
}

export async function getIv() {
  // #ifdef H5
  if (!cachedCryptoJS) {
    cachedCryptoJS = await import('crypto-js') // 复用缓存
  }
  return cachedCryptoJS.default.lib.WordArray.random(16).toString(cachedCryptoJS.default.enc.Hex)
  // #endif
}

export async function encryptedPwd(aesKey, iv, val) {
  // #ifdef H5
  if (!cachedCryptoJS) {
    cachedCryptoJS = await import('crypto-js') // 复用缓存
  }
  return cachedCryptoJS.default.AES.encrypt(
    val.toString(),
    cachedCryptoJS.default.enc.Hex.parse(aesKey), // 转换为WordArray类型密钥
    {
      mode: cachedCryptoJS.default.mode.CBC,
      padding: cachedCryptoJS.default.pad.Pkcs7,
      iv: cachedCryptoJS.default.enc.Hex.parse(iv) // 使用随机IV
    }
  ).toString()
  // #endif
}
